<template>
  <div>
    <ol class="iv-main-width iv-activity-my-registration iv-p-t-24 iv-p-b-40">
      <li 
        v-for="(item, index) in activityList" 
        :key="index" 
        class="iv-border-color iv-p-t-24 iv-p-b-24 iv-ac-li"
      >
        <div class="iv-my-ac-left">
          <div style="display: flex;align-items: center;">
            <span
              class="iv-m-r-8 iv-ac-tag iv-m-r-10"
              :class="{'iv-ac-green': item.infoState == 'SBZT02', 'iv-ac-yellow': item.infoState == 'SBZT04', 'iv-ac-red': item.infoState == 'SBZT03'}"
            >{{stateMap[item.infoState]}}</span>
            <h3 class="iv-fs-16 iv-fc-85">
              <span class="iv-m-r-20">{{item.applicationName}}</span>
              <span>{{item.objectName}}</span>
            </h3>
          </div>
          <p class="iv-fs-16 iv-fc-65 iv-m-t-12">发布组织：{{item.publishOrgName}}</p>
          <p class="iv-fs-16 iv-fc-65 iv-m-t-12">
            活动时间：{{timeFormat(item.eventStartTime, 'yyyy-MM-dd HH:mm:ss')}} ~ {{timeFormat(item.eventEndTime, 'yyyy-MM-dd HH:mm:ss')}}
          </p>
          <p class="iv-fs-16 iv-fc-65 iv-m-t-12">报名截止：{{timeFormat(item.applicationDeadline, 'yyyy-MM-dd HH:mm:ss')}}</p>
        </div>
        <div class="iv-my-ac-right">
          <div class="iv-text-right">
            <span class="iv-my-ac-right-btn iv-pointer iv-fc-85 iv-text-center iv-m-l-16" @click="toDetail(item)">查看详情</span>
          </div>
          <ul class="iv-my-ac-right-state">
            <li class="iv-m-r-32">
              <span class="iv-ac-out iv-m-r-8 iv-ac-out-active">
                <span class="iv-ac-inside"></span>
              </span>
              <span class="iv-ac-text iv-fs-12 iv-fc-45">报名时间：{{timeFormat(item.createTime, 'yyyy-MM-dd HH:mm:ss')}}</span>
            </li>
            <li class="iv-m-r-32">
              <span class="iv-ac-out iv-m-r-8" :class="{'iv-ac-out-active': item.isSignUp}">
                <span class="iv-ac-inside"></span>
              </span>
              <span class="iv-ac-text iv-fs-12 iv-fc-45">确定名单</span>
            </li>
            <li>
              <span class="iv-ac-out iv-m-r-8" :class="{'iv-ac-out-active': item.signInMethod == '1'}">
                <span class="iv-ac-inside"></span>
              </span>
              <span class="iv-ac-text iv-fs-12 iv-fc-45">活动签到</span>
            </li>
          </ul>
        </div>
      </li>
    </ol>
    <Page
      v-if="showPage" 
      :total="total" 
      :current="currentPage" 
      :pageSize="pageSize" 
      :pageSizeOpts="[6, 9, 15, 30]"
      class="iv-activity-content-page iv-m-t-40" 
      @on-change="changePage" 
      @on-page-size-change="changePageSize">
    </Page>
  </div>
</template>

<script>
import { timeFormat } from '@/utils'
import IconFont from '@/components/iconfont'

export default {
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      activityList: [],
      showPage: false,
      total: 0,
      currentPage: 1,
      pageSize: 9
    }
  },
  created () {
    this.stateMap = {
      'SBZT01': '未发布',
      'SBZT02': '已发布',
      'SBZT03': '已撤销',
      'SBZT04': '结束归档'
    }
    this.activityList = this.list
  },
  watch: {
    list () {
      this.activityList = this.list
    }
  },
  inject: ['getMyRegistrationList'],
  methods: {
    timeFormat,
    //查看详情
    toDetail (item) {
      this.$router.push({
        name: 'activityDetail',
        query: {
          applicationInfoId: item.applicationInfoId,
          isSignUp: 'yes'
        }
      })
    },
    //分页
    changePage (num) {
      this.currentPage = num
      this.getMyRegistrationList(this.pageSize, this.currentPage)
    },
    //条数
    changePageSize (num) {
      this.currentPage = 1
      this.pageSize = num
      this.getMyRegistrationList(this.pageSize, this.currentPage)
    }
  },
  components: {
    IconFont
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/base/variable.scss';
.iv-activity-my-registration {
  background-color: #fff;
  .iv-ac-li {
    display: flex;
    align-items: center;
    border-bottom: 1px dashed;
    width: 100%;
    .iv-my-ac-left {
      width: 64%;
      .iv-ac-tag {
        border: 1px solid;
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        border-radius: 4px;
        padding: 0 8px;
      }
      .iv-ac-green {
        color: #45BC7D;
        border-color: #45BC7D;
      }
      .iv-ac-yellow {
        color: #FFC757;
        border-color: #FFC757;
      }
      .iv-ac-red {
        color: #FA2900;
        border-color: #FA2900;
      }
    }
    .iv-my-ac-right {
      position: relative;
      width: 36%;
      height: 132px;
      .iv-my-ac-right-state {
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 0;
        right: 0;
        li {
          display: flex;
          align-items: center;
          .iv-ac-out {
            width: 14px;
            height: 14px;
            display: inline-block;
            border-radius: 50%;
            border: 1px solid rgba(0,0,0,0.25);
            background: #fff;
          }
          .iv-ac-out-active {
            background: #45BC7D;
            border-color: #45BC7D;
            display: flex;
            align-items: center;
            justify-content: center;
            .iv-ac-inside {
              width: 6px;
              height: 6px;
              display: inline-block;
              border-radius: 50%;
              background: #fff;
            }
          }
        }
      }
      .iv-my-ac-right-btn {
        display: inline-block;
        min-width: 108px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        border-radius: 20px;
        border: 1px solid rgba(0, 0, 0, 0.25);
        &:hover {
          color: $iv-main-hover-color !important;
          border-color: $iv-main-hover-color !important;
        }
      }
    }
  }
  .iv-no-bo {
    border: none;
  }
}
</style>
